module.exports = require("imagemin-optipng");;